<ul class="timeline-list">
  <app-timeline-item
    class="timeline-list__item"
    *ngFor="let item of collection; index as itemIndex"
    [index]="itemIndex"
    [item]="item"
  ></app-timeline-item>
</ul>
